import { userApi } from '@/entities/user';
export async function checkExpiresWithin(minutes: number) {
    const user = await userApi.get();

    if (user) {
        const targetDate = new Date(Date.now() + minutes * 60 * 1000);
        if (targetDate.getTime() <= new Date(user.expiresAt).getTime()) {
            return false;
        }
    }

    return true;
}
